<template>
  <div>


    <div class="price-list-block defualt-price attribute_pricing"  v-if="enabled_first_time_offer_TimeOfferValue" style="text-align:center" >

      <div class="price-list  ">
        <p>{{ trans.first_time_offer }}</p>

        <div v-if="hasFirstTimeOffer" class="first_time_offer_discount text-center float-left w-percentage-100  m-bottom-20">
                        <span class="font-size-20 font-weight-200">
                        {{serviceFirstTimeDiscountType_sign}}{{ serviceFirstTimeOffer }}
                        </span>
          <span class="font-size-15 ">{{ trans.discount }}</span>
        </div><!--first_time_offer_discount-->
      </div>

      <div v-if="notEmptyServiceDiscount" class="price-list ">

        <div class="price-row">
          <div class="row">
            <div class="col-xs-6">
              1 - {{ min_size_range }} {{ unit }}
            </div>
            <div class="col-xs-6">
              {{ currency_symbol }} {{ service.price }} {{ per }} {{ unit }}
            </div>
          </div>
        </div>

        <div class="price-row" v-for="(serviceDiscount, index ) in serviceDiscounts" :key="index">
          <div class="row">
            <div class="col-xs-6">
              {{ serviceDiscount.min_size_range }} - {{ serviceDiscount.max_size_range }} {{ unit}}
            </div>
            <div class="col-xs-6">
              {{currency_symbol}}{{ serviceDiscount.price_with_discount }} {{ per }} {{ unit }}

            </div>
          </div>
        </div>

      </div>


    </div>

    <div class="col-md-3 defualt-price attribute_pricing width-ipad-100" v-if="( rates.length != 0 ) || (minPrice && websiteSettings.show_min_price) " style="text-align:center !important">
      <div class="price-list " v-if="minPrice && websiteSettings.show_min_price">
        <label class="label-form"><span style="font-size: 1.6em; font-weight: normal;">{{ minPrice }}</span></label>
      </div>

      <div class="price-list " v-if="rates.length != 0">
        <service-view-right-menu-price-list_rates
            :service="service" :currency="currency" :rates="rates" :unit="unit"
        ></service-view-right-menu-price-list_rates>
      </div>
    </div>



  </div>
</template>


<script>

import ServiceViewRightMenuPriceList_rates from "./ServiceViewRightMenuPriceList_rates";

export default {
  name: "ServiceViewRightMenuPriceList_offers_discount",
  components: {ServiceViewRightMenuPriceList_rates},
  props: [
    'trans',
    'enabled_first_time_offer_TimeOfferValue',
    'hasFirstTimeOffer',
    'serviceFirstTimeDiscountType_sign',
    'serviceFirstTimeOffer',
    'notEmptyServiceDiscount',
    'service_unit_price',
    'unit',
    'min_size_range',
    'per',
    'currency_symbol',
    'service',
    'show_pricing_list_in_view_service_page',
    'display_button',
    'serviceDiscounts',
    'currency',
    'rates',
    'minPrice',
    'websiteSettings',
  ],
  data() {
    return {

    }
  },
  methods:{

  },
  computed: {

  },
  mounted(){
  }
}
</script>

